import { useTranslation } from 'react-i18next';



export const ErrorPage = () => {
	const { t } = useTranslation('global');

	return (
		<div className="app-error-page">
			
			<h1>{t('pages.errorHeader')}</h1>

			<p>{t('pages.errorText')}</p>

		</div>
	);
};